import React, { useContext } from 'react';
import LayoutButton from '@src/components/wysiwyg_editor/toolbox/buttons/Layout';
import TextButton from '@src/components/wysiwyg_editor/toolbox/buttons/Text';
import PhotosButton from '@src/components/wysiwyg_editor/toolbox/buttons/Photos';

import LayoutDrawer from '@src/components/wysiwyg_editor/toolbox/drawers/Layout';
import TextDrawer from '@src/components/wysiwyg_editor/toolbox/drawers/Text';
import PhotosDrawer from '@src/components/wysiwyg_editor/toolbox/drawers/Photos';

import { WysiwygEditorStateContext } from '@src/contexts/wysiwyg/editor';

function StencilToolbox(): React.ReactElement {
  const { activeToolboxTab: activeTab } = useContext(WysiwygEditorStateContext);

  return (
    <div className="wysiwyg-editor-toolbox" data-active-tab={activeTab}>
      <div className="wysiwyg-editor-toolbox-buttons">
        <LayoutButton active={activeTab === 'layout'} />
        <PhotosButton active={activeTab === 'photos'} />
        <TextButton active={activeTab === 'text'} />
      </div>
      {activeTab === 'layout' ? (
        <LayoutDrawer />
      ) : activeTab === 'photos' ? (
        <PhotosDrawer />
      ) : activeTab === 'text' ? (
        <TextDrawer />
      ) : null}
    </div>
  );
}

export default StencilToolbox;
